// src/app/core/interceptors/auth.interceptor.ts

import { HttpInterceptorFn } from '@angular/common/http';
import { inject, untracked } from '@angular/core';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

import { AuthStore } from '../store/auth.store';
import { LoginFirebaseService } from 'src/app/features/auth/log-in/services/login-firebase.service';

import { BYPASS_AUTH } from '../tokens/auth.tokens';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const store = inject(AuthStore);
  const authService = inject(LoginFirebaseService);
  const router = inject(Router);

  const skipAuth = req.context.get(BYPASS_AUTH);
  const isAuthRequest = req.url.includes('/api/v1/login/auth');

  if (skipAuth) return next(req);
  if (isAuthRequest) return next(req);

  return untracked(() => {

    const status$ = toObservable(store.status);

    return status$.pipe(
      filter(status => status !== 'init' && status !== 'loading'),
      take(1),
      switchMap((status) => {

        const existingAuth = req.headers.get('Authorization');
        const token: string | null = existingAuth ? existingAuth.replace('Bearer ', '') : (authService.firebaseIdToken() || store.token());

        if (status === 'authenticated' && (token || existingAuth)) {

          const headersToSet: any = {
            token_type: 'firebase'
          };
          if (!existingAuth && token) {
            headersToSet['Authorization'] = `Bearer ${token}`;
          }

          const clonedRequest = req.clone({
            setHeaders: headersToSet
          });

          return next(clonedRequest).pipe(
            catchError((error) => {
              if (error.status === 401) {
                store.logout();
                router.navigate(['/auth']);
              }
              return throwError(() => error);
            })
          );
        }

        router.navigate(['/auth']);
        return throwError(() => new Error('Usuario no autenticado.'));
      })
    );
  });
};
